import React, { useState, useEffect, useContext } from "react";
import styles from "./BatchRemewModal.module.css";
import { apiUrl } from "../../Constants/Constants";
import NumberComponent from "../NumberComponent";
// import FetchWithToken from "../FetchWithToken/FetchWithToken";
import { AuthContext } from "../../Constants/AuthProvider";
import { redirect } from "react-router-dom";
import { useFetchWithToken } from "./../FetchWithToken/FetchWithToken";
import { ConfirmationModalContext } from "../../fautures/ConfirmationModalProvider";
import { createBatchRenewModalLogic } from "./BatchRenewModal.logic";
import Loading from "./../Loading/Loading.module";
import BlueBtn from "../BlueBtn/BlueBtn.module";
import CtaBtns from "../CtaBtns/CtaBtns.module";
import CheckBox from "../CheckBox/CheckBox.module";
const BatchRenewModal = ({
  isOpen,
  onClose,
  fetchAccounts,
  userWallet,
  getInfo,
  setAutoRenewModalOpen,
  loadingShow,
}) => {
  const modalContext = useContext(ConfirmationModalContext);
  const [titlIng, setTitlIng] = useState("انتخاب اکانت ");
  const { onLogout } = React.useContext(AuthContext);
  const [accounts, setAccounts] = useState([]);
  const [selectedAccounts, setSelectedAccounts] = useState([]);
  const [currentStep, setCurrentStep] = useState(1);
  const { loading, fetchWithToken } = useFetchWithToken();
  const formatPrice = (price) => {
    if (price == null) return "در حال بارگذاری...";
    return `${price.toLocaleString("fa-IR")} تومان`;
  };

  const { fetchPaymentUrl, paybatchRenewPay } = createBatchRenewModalLogic(
    {
      fetchWithToken,
      getInfo,
      onLogout,
      closeFinalModal: onClose,
      getInfo,
    },
    modalContext
  );

  // دریافت لیست اکانت‌ها هنگام باز شدن مودال
  useEffect(() => {
    if (isOpen) {
      const loadAccounts = async () => {
        const data = await fetchAccounts();
        const filteredAccounts = data.filter(
          (account) => account.remainingTime.days < 2 && account.price !== 0
        );
        setAccounts(filteredAccounts);
      };
      loadAccounts();
    }
  }, [isOpen, fetchAccounts]);

  // مدیریت انتخاب/عدم انتخاب اکانت
  const handleSelect = (accountId) => {
    setSelectedAccounts(
      (prev) =>
        prev.includes(accountId)
          ? prev.filter((id) => id !== accountId) // حذف از لیست انتخاب‌شده
          : [...prev, accountId] // افزودن به لیست انتخاب‌شده
    );
  };
  useEffect(() => {
    loadingShow(loading);
  }, [loading]);
  // محاسبه مجموع مبلغ
  const calculateTotal = () => {
    if (selectedAccounts.length != 0 && accounts.length != 0) {
      return selectedAccounts.reduce((sum, accountId) => {
        const account = accounts.find((acc) => acc.id === accountId);
        const price = account.discounts
          ? account.discounts.priceAfterDiscount
          : account.price;
        return sum + price;
      }, 0);
    } else {
      setCurrentStep(1);
    }
  };
  useEffect(() => {
    switch (currentStep) {
      case 1:
        setTitlIng("انتخاب اکانت ");
        break;
      case 2:
        setTitlIng("صورتحساب شما");
        break;
      case 3:
        setTitlIng("انتخاب محل پرداخت");
        break;
    }
  }, [currentStep]);
  if (!isOpen) return null;

  return (
    <div className={styles.custommodaloverlay} onClick={onClose}>
      <div
        className={styles.custommodalcontent}
        onClick={(e) => e.stopPropagation()}
      >
        <div className={styles.topBoxIcons}>
          <div className={styles.rightIconTop}>
            <i class="fa-solid fa-cart-plus"></i>
          </div>
          <button className={styles.custommodalclose} onClick={() => onClose()}>
            ×
          </button>
        </div>

        <div className={styles.renewtitle}>تمدید اکانت ها</div>
        <div className={styles.btnonautorenew}>
          <CtaBtns
            icon="fa-thin fa-bolt-auto"
            onAtion={() => setAutoRenewModalOpen("open")}
          >
            تمدید خودکار اکانت ها
          </CtaBtns>
        </div>
        <div className={styles.renewtitle}>{titlIng}</div>

        {currentStep === 1 && (
          <>
            <p className={styles.descrenew}>
              لطفاً اکانت‌هایی که می‌خواهید تمدید شوند را انتخاب کنید:
            </p>
            <div className={styles.accountlist}>
              {accounts.length !== 0 ? (
                accounts.map((account) => (
                  <div
                    key={account.id}
                    className={`${styles.accountcard} ${
                      selectedAccounts.includes(account.id)
                        ? styles.selected
                        : ""
                    }`}
                    onClick={() => handleSelect(account.id)}
                  >
                    <CheckBox checked={selectedAccounts.includes(account.id)} />
                    {"discounts" in account ? (
                      <>
                        <p>
                          <span className={styles.discountedprice}>
                            {formatPrice(account.discounts.priceAfterDiscount)}
                          </span>
                          <span className={styles.originalprice}>
                            {formatPrice(account.price)}
                          </span>
                        </p>
                        <p>
                          <span className={styles.discountpercent}>
                            {NumberComponent(account.discounts.discountPercent)}
                            %
                          </span>{" "}
                          تخفیف
                        </p>
                      </>
                    ) : (
                      <p className={styles.price}>
                        {formatPrice(account.price)}
                      </p>
                    )}
                    <p className={styles.remainingtime}>
                      {NumberComponent(account.remainingTime.days)} روز مانده
                    </p>
                    <div className={styles.tit}>
                      {account.accountName}
                      <i class="far fa-user"></i>
                    </div>
                  </div>
                ))
              ) : (
                <div style={{ fontFamily: "light", color: "white" }}>
                  هیچ یک از اکانت های شما به موعد تمدید نزدیک نیستند
                </div>
              )}
            </div>
            <div className={styles.modalactions}>
              <CtaBtns
                className={styles.gonext}
                onAtion={() => setCurrentStep(2)}
                disabled={selectedAccounts.length === 0}
              >
                مشاهده صورتحساب
              </CtaBtns>
            </div>
          </>
        )}

        {currentStep === 2 && (
          <>
            <p className={styles.accountcount}>
              تعداد اکانت‌ها: {NumberComponent(selectedAccounts.length)}
            </p>
            <div className={styles.accountlist2}>
              {selectedAccounts.map((accountId) => {
                const account = accounts.find((acc) => acc.id === accountId);
                return (
                  <div key={account.id} className={styles.accountcard}>
                    <div className={styles.tit}>{account.accountName}</div>

                    {"discounts" in account ? (
                      <>
                        <p>
                          <span className={styles.discountedprice}>
                            {formatPrice(account.discounts.priceAfterDiscount)}
                          </span>
                          <span className={styles.originalprice}>
                            {formatPrice(account.price)}
                          </span>
                        </p>
                        <p>
                          <span className={styles.discountpercent}>
                            {NumberComponent(account.discounts.discountPercent)}
                            %
                          </span>
                          تخفیف
                        </p>
                      </>
                    ) : (
                      <p className={styles.price}>
                        {formatPrice(account.price)}
                      </p>
                    )}
                    <p>
                      {NumberComponent(account.remainingTime.days)} روز مانده
                    </p>
                  </div>
                );
              })}
            </div>
            <div className={styles.invoiceSummary}>
              <p>مجموع مبلغ قابل پرداخت: {formatPrice(calculateTotal())}</p>
            </div>
            <div className={styles.modalactions}>
              <CtaBtns
                className={styles.goback}
                onAtion={() => setCurrentStep(1)}
              >
                بازگشت
              </CtaBtns>
              <CtaBtns
                className={styles.gonext}
                onAtion={() => setCurrentStep(3)}
              >
                پرداخت
              </CtaBtns>
            </div>
          </>
        )}

        {currentStep === 3 && (
          <>
            <div className={styles.invoiceSummary}>
              <p>مجموع مبلغ قابل پرداخت: {formatPrice(calculateTotal())}</p>
            </div>
            <div className={styles.choosepayment}>
              <div
                className={
                  calculateTotal() > userWallet
                    ? `${styles.eachitemonpayment} ${styles.disablePayment}`
                    : styles.eachitemonpayment
                }
                onClick={() =>
                  calculateTotal() <= userWallet &&
                  paybatchRenewPay(selectedAccounts, calculateTotal())
                }
              >
                <div className={styles.topicon}>
                  <i class="fa-light fa-wallet"></i>
                </div>
                <div className={styles.textofpay}>
                  کیف پول
                  {calculateTotal() > userWallet && (
                    <>
                      <br />
                      عدم موجودی کافی
                    </>
                  )}
                </div>
              </div>
              <div
                className={styles.eachitemonpayment}
                onClick={() => fetchPaymentUrl(selectedAccounts)}
              >
                <div className={styles.topicon}>
                  <i class="fa-light fa-credit-card-front"></i>
                </div>
                <div className={styles.textofpay}>درگاه پرداخت</div>
              </div>
            </div>
            <div className={styles.modalactions}>
              <CtaBtns
                className={styles.goback}
                onAtion={() => setCurrentStep(2)}
              >
                بازگشت
              </CtaBtns>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default BatchRenewModal;
